import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { utils } from '@costar/theme-ui';
import { useMemo } from 'react';

var _excluded = ["type", "size", "className", "listProps", "options", "resolveText", "showSelectionCheckbox", "multiple", "onChange", "initialSelection", "renderItem", "renderPopoverContent", "extendedContent", "extendedContentTop", "placeHolder", "popoverProps", "fullWidthPopover", "containerElement", "selection", "paneProps", "placeHolderProps", "icon", "automation-id", "renderSelection", "onClose"];
function useExtractProps(props) {
  return useMemo(function () {
    var _props$type = props.type,
      type = _props$type === void 0 ? 'default' : _props$type,
      size = props.size,
      className = props.className,
      _props$listProps = props.listProps,
      _listProps = _props$listProps === void 0 ? utils.EMPTY_OBJECT : _props$listProps,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      _props$resolveText = props.resolveText,
      resolveText = _props$resolveText === void 0 ? function (v) {
        return "".concat(v);
      } : _props$resolveText,
      showSelectionCheckbox = props.showSelectionCheckbox,
      isMultiSelect = props.multiple,
      onChange = props.onChange,
      initialSelection = props.initialSelection,
      renderItem = props.renderItem,
      renderPopoverContextProps = props.renderPopoverContent,
      extendedContent = props.extendedContent,
      extendedContentTop = props.extendedContentTop,
      _props$placeHolder = props.placeHolder,
      placeHolder = _props$placeHolder === void 0 ? 'Select Item' : _props$placeHolder,
      _props$popoverProps = props.popoverProps,
      popoverProps = _props$popoverProps === void 0 ? utils.EMPTY_OBJECT : _props$popoverProps,
      fullWidthPopover = props.fullWidthPopover,
      containerElement = props.containerElement,
      selectionProps = props.selection,
      paneProps = props.paneProps,
      _props$placeHolderPro = props.placeHolderProps,
      placeHolderProps = _props$placeHolderPro === void 0 ? {
        color: 'neutral.dark'
      } : _props$placeHolderPro,
      _props$icon = props.icon,
      iconProps = _props$icon === void 0 ? utils.EMPTY_OBJECT : _props$icon,
      automationId = props['automation-id'],
      renderSelection = props.renderSelection,
      onClose = props.onClose,
      rest = _objectWithoutProperties(props, _excluded);
    return {
      type: type,
      size: size,
      className: className,
      _listProps: _listProps,
      options: options,
      resolveText: resolveText,
      showSelectionCheckbox: showSelectionCheckbox,
      isMultiSelect: isMultiSelect,
      onChange: onChange,
      initialSelection: initialSelection,
      renderItem: renderItem,
      renderPopoverContextProps: renderPopoverContextProps,
      extendedContent: extendedContent,
      extendedContentTop: extendedContentTop,
      placeHolder: placeHolder,
      popoverProps: popoverProps,
      fullWidthPopover: fullWidthPopover,
      containerElement: containerElement,
      selectionProps: selectionProps,
      paneProps: paneProps,
      placeHolderProps: placeHolderProps,
      iconProps: iconProps,
      automationId: automationId,
      renderSelection: renderSelection,
      onClose: onClose,
      rest: rest
    };
  }, [props]);
}

export default useExtractProps;
//# sourceMappingURL=use-extract-props.esm.js.map
